import { z } from 'zod';

export const TraceTagSchema = z.object({
  key: z.string(),
  type: z.any(),
  value: z.union([z.string(), z.number(), z.boolean()]),
});

export type TraceTag = z.infer<typeof TraceTagSchema>;

export const TraceSpanSchema: z.ZodType<TraceSpan> = z.lazy(() =>
  z.object({
    id: z.string(),
    parentSpanId: z.string().nullable(),
    operationName: z.string(),
    startTime: z.number(),
    endTime: z.number(),
    duration: z.number(),
    tags: z.array(TraceTagSchema),
    children: z.array(TraceSpanSchema),
  })
);

export interface TraceSpan {
  id: string;
  parentSpanId: string | null;
  operationName: string;
  startTime: number;
  endTime: number;
  duration: number;
  tags: TraceTag[];
  children: TraceSpan[];
}
